import { useFormContext } from "react-hook-form";
import { classes } from "../../../../util/style-utils";
import RadioButtonGroup from "../../../gds/RadioButtonGroup";
import SelectBox from "../../../gds/SelectBox";
import YesNoOptions from "../../../../constants/options/YesNoOptions";
import CaptiveCarrierOptions from "../../constants/options/CaptiveCarrierOptions";
import { useEffect } from "react";

/**
 * CaptiveAgentQuestions component handles the captive agent related questions
 * including carrier selection and other carrier specification.
 * Only renders for users with the "principal" role.
 */
export default function CaptiveAgentQuestions() {
    const { register, watch, control, formState: { errors }, setValue } = useFormContext();

    // Watch form values
    const watchRole = watch("role");
    const watchCaptiveAgent = watch("captiveAgent");
    const watchCaptiveCarrier = watch("captiveCarrier");

    useEffect(() => {
        if (watchCaptiveAgent === "false") {
            setValue("captiveCarrier", "");
            setValue("captiveCarrierOther", "");
        }
    }, [watchCaptiveAgent]);

    // Only render for principals
    if (watchRole !== "principal") {
        return null;
    }

    return (
        <div>
            <div className="flex-row">
                <RadioButtonGroup
                    control={control}
                    name="captiveAgent"
                    legend={<>
                        Are you currently a captive agent with any insurance carrier?<span className="required">*</span>
                    </>}
                    layout="Two Column"
                    options={YesNoOptions}
                />
            </div>

            {watchCaptiveAgent === "true" &&
                <div className="flex-row">
                    <SelectBox
                        control={control}
                        name="captiveCarrier"
                        label={<>For which carrier are you a captive agent?<span className="required">*</span></>}
                        placeholder="Please Select"
                        options={CaptiveCarrierOptions}
                    />

                    {watchCaptiveCarrier === "other" &&
                        <div className={classes("form-field", errors.captiveCarrierOther && "form-field--error")}>
                            <label htmlFor="captive-carrier-other" className="text">
                                Please Specify Carrier<span className="required">*</span>
                            </label>
                            <input
                                id="captive-carrier-other"
                                type="text"
                                size="30"
                                {...register("captiveCarrierOther")}
                            />
                            {errors.captiveCarrierOther && (
                                <span className="form-message">
                                    {errors.captiveCarrierOther.message}
                                </span>
                            )}
                        </div>
                    }
                </div>
            }
        </div>
    );
}
